<mat-form-field
  appearance="outline"
  color="primary"
  class="full-width date-size"
  >
  <mat-label [attr.for]="field.key">{{ field.label }}</mat-label>
  <input
    matInput
    [matDatepicker]="picker"
    [formControlName]="field.key"
    [id]="field.key"
    [min]="minDate"
    [max]="maxDate"
    />
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [calendarHeaderComponent]="customHeader">
      <mat-datepicker-actions>
        <button mat-button color="primary" matDatepickerCancel class="date-btn">
          Cancelar
        </button>
        <button mat-button color="primary" matDatepickerApply class="date-btn">
          Aceptar
        </button>
      </mat-datepicker-actions>
    </mat-datepicker>
    @if (controlContainer.control?.get(field?.key)?.hasError('required')) {
      <mat-error
        >Debe completar el campo.</mat-error
        >
    }
  </mat-form-field>
